import { Observable } from 'rxjs';
import { Api } from '../_services/api';
import { Injectable } from '@angular/core';

@Injectable()
export class UserApi {
    constructor(private api: Api) {

    }

    login(email: string, pwd: string) {
        return this.api.post("/users/login", { userid: email, password: pwd });
    }

    list(): Observable<any[]> {
        return this.api.get<any[]>("/users/list", null);
    };

    get(id) {
        return this.api.post("/users/get", { id: id });
    }

    getAction(id) {
        return this.api.post("/users/action/get", { id: id });
    }

    check(email) {
        return this.api.post("/users/available", { id: email });
    }

    register(user) {
        return this.api.post("/users/register", user);
    }

    create(data) {
        return this.api.post("/users/add", data);
    }

    edit(data) {
        return this.api.post("/users/edit", data);
    }

    editLocation(userid: string, loc: string[]) {
        return this.api.post("/location/user/edit", { user_id: userid, locations: loc });
    }

    editAction(data) {
        return this.api.post("/users/action/edit", { actionObj: data });
    }

    delete(userid) {
        return this.api.post('/users/delete', { userid: userid });
    }

    chgPwd(userid, opwd, pwd) {
        return this.api.post('/users/password/edit', { userid: userid, oldPwd: opwd, newPwd: pwd });
    }

    // create(data: Package): Observable<any> {
    //     return this.api.post("/packages/add", data);
    // }

    // update(data: Package): Observable<any> {
    //     return this.api.post("/packages/edit", data);
    // }

    // delete(id: number) {
    //     return this.api.post("/packages/delete", { id: id });
    // }
}


// WEBPACK FOOTER //
// ./src/app/api/api-user.ts